import React from "react";
import InitialPropsContext from "../lib/models/initialPropsContext";
import PageProps from "../lib/models/pageProps";
import { RepaymentCalculator } from "../lib/CmsApi";
import Tilgungsrechner from "../components/tilgungsrechner";
import PageNotFoundError from "../lib/pageNotFoundError";

export default function Page(props: RepaymentCalculator) {
  return <Tilgungsrechner {...props} />;
}

Page.getInitialProps = async ({
  api
}: InitialPropsContext): PageProps<RepaymentCalculator> => {
  const [document] = await Promise.all([
    api.loadRepaymentCalculator().catch(() => {
      throw new PageNotFoundError();
    })
  ]);
  return document;
};
